<script>
import { mapActions, mapGetters } from "vuex";
import AlertError from "@/components/alert_error";
import Loader from "@/components/widgets/loader";
import { swal } from "../../../../helpers/handle_error";
import exportToExcel from "../../../../helpers/export_to_excel";

export default {
  components: { AlertError, Loader },
  data() {
    return {
      //Page errors.
      errors: [],
      showLoader: true,
      showAlert: false,

      items: [],

      // datatable
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      totalItems: 0,
      totalItemsFiltered: 0,
      pageOptions: [
        10,
        25,
        50,
        100,
        { value: Number.MAX_SAFE_INTEGER, text: "عرض الكل" },
      ],
      filter: "",
      filterOn: [],
      sortBy: "created_at",
      sortDesc: true,
      fields: [
        {
          // A virtual column that doesn't exist in items
          label: "ت",
          key: "index",
          sortable: true,
          visible: true,
          //for join datatable.
          isVirtual: true,
          name: "",
          searchable: false,
        },
        {
          label: "الاسم الرباعي",
          key: "personal_info.full_name",
          sortable: true,
          visible: true,
          //for join datatable.
          isVirtual: false,
          name: "personalInfo.full_name",
          searchable: true,
        },
        {
          label: "اللقب",
          key: "personal_info.family_name",
          sortable: true,
          visible: true,
          //for join datatable.
          isVirtual: false,
          name: "personalInfo.family_name",
          searchable: true,
        },
        {
          label: "الاسم الام",
          key: "personal_info.mother_name",
          sortable: true,
          visible: true,
          //for join datatable.
          isVirtual: false,
          name: "personalInfo.mother_name",
          searchable: true,
        },
        {
          label: "الرقم التقاعدي",
          key: "retirement_number",
          sortable: true,
          visible: true,
          //for join datatable.
          isVirtual: false,
          name: "retirement_number",
          searchable: true,
        },
        {
          label: "تاريخ الانشاء",
          key: "created_at",
          sortable: true,
          visible: true,
          //for join datatable.
          isVirtual: false,
          name: "created_at",
          searchable: true,
        },
        {
          label: "الاجراءات",
          key: "settings",
          class: "col-setting-services",
          sortable: true,
          visible: this.$store.getters["auth/getUser"].hasAnyPermission([
            "show_details_land",
            "delete_land",
          ]),
          //for join datatable.
          isVirtual: true,
          name: "",
          searchable: false,
        },
      ],
    };
  },
  computed: {
    ...mapGetters("plotsOfLandMartyr", ["getMartyrs"]),
    start() {
      return (this.currentPage - 1) * this.perPage + 1;
    },
    end() {
      return Math.min(this.currentPage * this.perPage, this.totalItems);
    },
  },
  methods: {
    visibleFields() {
      return this.fields.filter((field) => field.visible);
    },
    handleError(error) {
      alert(error);
      this.showAlert = true;
      if (error.response.status == 422)
        this.errors = Object.values(error.response.data.errors);
      else
        this.errors = [
          `Error Code : ${error.response.status}  Message : ${error.response.data.message}`,
        ];
    },
    ...mapActions("plotsOfLandMartyr", ["getAll", "delete"]),
    // datatable
    search() {
      if (this.currentPage == 1) this.fetchAll();
      else this.currentPage = 1;
    },
    fetchAll() {
      this.showLoader = true;

      var query = new URLSearchParams({
        draw: this.currentPage,
        start: (this.currentPage - 1) * this.perPage,
        length: this.perPage,
      });
      query.append("_datatable", "1");
      let columns = this.fields.filter((f) => !f.isVirtual);
      columns.forEach((el, index) => {
        query.append("columns[" + index + "][data]", el.name);
        query.append("columns[" + index + "][name]", el.name);
        query.append("columns[" + index + "][orderable]", el.sortable);
        query.append("columns[" + index + "][searchable]", el.searchable);
        query.append("columns[" + index + "][search][value]", "");
        query.append("columns[" + index + "][search][regex]", "false");
      });
      query.append("search[value]", this.filter);
      query.append("search[regex]", "false");

      this.getAll(query)
        .then((response) => {
          this.totalItemsFiltered = response.data.recordsFiltered;
          this.totalItems = response.data.recordsTotal;

          this.items = this.getMartyrs;
          this.showLoader = false;
        })
        .catch((error) => {
          this.handleError(error);
          this.showLoader = false;
        });
    },
    async deleteItem(id) {
      if (await swal.confirm()) {
        swal.loading();
        this.delete(id)
          .then((response) => {
            this.fetchAll();
            swal.success(response.data.message);
          })
          .catch((error) => {
            this.handleError(error);
            swal.close();
          });
      }
    },
    exportTable() {
      exportToExcel(this.visibleFields(), this.items, "استمارة قطع الاراضي (الشهيد)");
    },
  },
  watch: {
    currentPage: {
      handler: function () {
        this.fetchAll();
      },
    },
    perPage: {
      handler: function () {
        this.fetchAll();
      },
    },
  },
  created() {
    this.fetchAll();
  },
};
</script>

<template>
  <div>
    <Loader :loading="showLoader">
      <div class="row mt-3">
        <div class="col-12">
          <AlertError :showDismissibleAlert="showAlert" :errors="errors"></AlertError>

          <!-- Header Table -->
          <div class="row mt-1">
            <!-- table_length -->
            <div class="col-sm-12 col-md-6">
              <div id="tickets-table_length" class="dataTables_length">
                <label class="d-inline-flex align-items-center">
                  عرض&nbsp;:&nbsp;
                  <b-form-select
                    class="form-select form-select-sm"
                    v-model="perPage"
                    size="sm"
                    :options="pageOptions"
                  ></b-form-select>
                  &nbsp;مدخلات
                </label>
              </div>
            </div>
            <!-- Search -->
            <div class="col-sm-12 col-md-6">
              <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                <label class="d-inline-flex align-items-center">
                  بحث&nbsp;:&nbsp;
                  <b-form-input
                    v-model="filter"
                    @input="search"
                    type="search"
                    placeholder="بحث..."
                    class="form-control form-control-sm ms-2"
                  ></b-form-input>
                </label>
                <b-button class="btn-sm mx-2" variant="primary" @click="exportTable"
                  >Excel</b-button
                >
              </div>
            </div>
          </div>

          <!-- Table -->
          <div class="table-responsive mb-0">
            <b-table
              class="datatables"
              show-empty
              hover
              :items="items"
              :striped="true"
              :fields="visibleFields()"
              responsive="md"
              :current-page="currentPage"
              :per-page="0"
            >
              <!-- A virtual column -->
              <template #cell(index)="data">
                {{ data.index + 1 + (currentPage - 1) * perPage }}
              </template>

              <!-- A custom formatted column Sutting -->
              <template v-slot:cell(settings)="data">
                <div class="button-items">
                  <router-link
                    v-can="'show_details_land'"
                    :to="{
                      name: 'plotsOfLand.martyrs.details',
                      params: { id: data.item.id },
                    }"
                  >
                    <b-button class="btn-sm" variant="info">التفاصيل</b-button>
                  </router-link>
                  <b-button
                    v-can="'delete_land'"
                    class="btn-sm ml-1"
                    variant="danger"
                    title="حذف"
                    @click="deleteItem(data.item.id)"
                    ><i class="bx bx-trash"></i
                  ></b-button>
                </div>
              </template>
            </b-table>
          </div>

          <!-- Footer Table -->
          <div class="row">
            <div class="col">
              <div class="dataTables_paginate paging_simple_numbers float-end">
                <ul class="pagination pagination-rounded mb-0">
                  <!-- pagination -->
                  <b-pagination
                    v-model="currentPage"
                    :total-rows="totalItemsFiltered"
                    :per-page="perPage"
                  ></b-pagination>
                </ul>
              </div>
              <div class="dataTables_paginate paging_simple_numbers float-start">
                <p>
                  عرض من {{ start }} الى {{ end }} من مجموع {{ totalItemsFiltered }}
                  <spam v-if="totalItemsFiltered != totalItems"
                    >(تمت تصفيته من إجمالي {{ totalItems }} إدخالاً)</spam
                  >
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Loader>
  </div>
</template>
